import { render, staticRenderFns } from "./detail_discount.vue?vue&type=template&id=6b19362c&scoped=true"
import script from "./detail_discount.vue?vue&type=script&lang=js"
export * from "./detail_discount.vue?vue&type=script&lang=js"
import style0 from "./detail_discount.vue?vue&type=style&index=0&id=6b19362c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19362c",
  null
  
)

export default component.exports